<template>
  <v-dialog persistent v-model="display" :width="width">
    <v-card rounded="0" class="px-12">
      <div class="d-flex align-center pt-6 pb-2">
        <v-icon class="mr-2">mdi-camera</v-icon>
        <Typography variant="h-5">Crop your image</Typography>
      </div>
      <Typography variant="body-1" class="word-break pb-4 text-left">{{
        instructionText ||
        (aspectRatioText
          ? `Please crop the image below to a ${aspectRatioText} aspect ratio.`
          : "Please crop the image below")
      }}</Typography>
      <cropper
        ref="cropper"
        :src="imageUrl"
        :stencil-props="stencilProps"
        :default-size="getDefaultSize"
        @ready="setImageAltText"
        @change="setImageAltText"
      />
      <v-alert dense outlined v-if="!imageisPNG" type="error" class="mt-4">
        To avoid display issues we suggest a PNG logo file
      </v-alert>
      <v-card-actions class="pt-4">
        <v-spacer />
        <Button text color="brandPrimary" class="mr-4" @click="close(false)">Cancel</Button>
        <Button color="brandPrimary" :loading="loading" :disabled="loading" @click="close(true)"
          >Save</Button
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { Cropper } from "vue-advanced-cropper";
import "vue-advanced-cropper/dist/style.css";
import Button from "@/components/generic/Button.vue";
import Typography from "@/components/generic/Typography.vue";
import { croppedImageFile, croppedImageMimeType } from "@/utils/croppedImageFile";
import { setCropperImageAlt } from "@/utils/cropperImageAlt";

export default {
  name: "ImageCropper",
  components: { Cropper, Button, Typography },
  props: {
    width: {
      type: Number,
      default: 600,
    },
    aspectRatioValue: {
      type: Number,
      // default: 16 / 9
    },
    aspectRatioText: {
      type: String,
      // default: "16 : 9"
    },
    fileName: {
      type: String,
    },
    imageUrl: {
      type: String,
    },
    imageisPNG: {
      type: Boolean,
      default: true,
    },
    instructionText: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      display: true,
      loading: false,
    };
  },
  created() {
    console.log("Created ImageCropper");
  },
  methods: {
    close(save = false) {
      if (!save) return this.reset();

      this.loading = true;
      const cropperRef = this.$refs.cropper;
      const { canvas } = cropperRef.getResult();
      const mimeType = croppedImageMimeType(this.imageisPNG);
      canvas.toBlob((blob) => {
        const file = croppedImageFile(blob, this.fileName, mimeType);
        const imageUrl = canvas.toDataURL();
        this.newCompanyPicFile = file;
        this.newCompanyPicTemp = canvas.toDataURL();
        this.$emit("success", { file, imageUrl });
        this.loading = false;
        this.display = false;
        console.log("Successfully processed picture: ", file);
        // this.reset();
      }, mimeType);
    },
    reset() {
      this.$emit("close");
      this.display = false;
    },
    setImageAltText() {
      this.$nextTick(() => setCropperImageAlt(this.$refs.cropper?.$el, this.fileName));
    },
    getDefaultSize({ imageSize }) {
      const width = imageSize.width * 0.9;
      const height = Math.min(width / 4, imageSize.height * 0.9);
      return { width, height };
    },
  },

  computed: {
    stencilProps() {
      return this.aspectRatioValue ? { aspectRatio: this.aspectRatioValue } : {};
    },
  },
  watch: {
    display: function (newVal) {
      if (!newVal) this.$emit("close");
    },
  },
};
</script>

<style></style>
